const PROJECTS = [
  {
    id: 1,
    title: 'Rack Estruturado com Patch Panel',
    category: 'Cabeamento',
    description: 'Infraestrutura padronizada e organizada do zero — toda a rede da empresa centralizada em um único rack, com identificação profissional e espaço preparado para crescimento futuro.',
    tags: ['Rack', 'Patch Panel', 'Cabeamento'],
    image: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/c930e53d-f97e-4a42-a2be-abe646471b20_Rack-estrutrado-com-Patch-Panel.jpeg?v=d9f230d9f610999899e21d87434d7d1c',
  },
  {
    id: 2,
    title: 'Rede Wi-Fi Corporativa',
    category: 'Redes',
    description: 'Cobertura Wi-Fi completa em todo o ambiente da empresa — sinal forte em cada sala, sem pontos cegos, com internet rápida e estável para todos os colaboradores.',
    tags: ['UniFi', 'Wi-Fi', 'Cobertura Total'],
    image: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/eb0a26dc-af58-4d37-9194-9ec87ffc80d9_Rede-WiFi-Coorporativa.jpeg?v=fe590109ed1c95c248fbf6f2789ac7b4',
  },
  {
    id: 3,
    title: 'Sistema de Câmeras com Acesso Remoto',
    category: 'Segurança',
    description: 'Câmeras IP instaladas e configuradas para monitoramento em tempo real pelo celular — veja sua empresa de qualquer lugar, a qualquer hora, com total segurança.',
    tags: ['CFTV', 'Acesso Remoto', 'Monitoramento'],
    image: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/d68134e7-23e9-4a8a-b43e-4c776530277c_IMG_9305.JPG.jpeg?v=bd5c3395e27432a06fc6df89984c69d6',
  },
  {
    id: 4,
    title: 'Servidor de Arquivos e Backup',
    category: 'Servidores',
    description: 'Nunca mais perca um arquivo importante. Servidor configurado com backup automático diário e acesso centralizado a todos os documentos da empresa, de forma rápida e segura.',
    tags: ['Backup Automático', 'File Server'],
    image: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/1eabaf8c-95fe-4d63-a168-231b7150068e_Servidor-de-Arquivos-e-Backup.jpg?v=538e1d9f50d95ac7b94d02784166b605',
  },
  {
    id: 5,
    title: 'Microsoft 365 Corporativo',
    category: 'Microsoft 365',
    description: 'Empresa mais organizada e produtiva com e-mails profissionais, arquivos na nuvem, videoconferências e colaboração em equipe — tudo integrado em uma única plataforma.',
    tags: ['Microsoft 365', 'Teams', 'OneDrive', 'SharePoint'],
    image: 'https://readdy.ai/api/search-image?query=modern%20office%20with%20employees%20using%20laptop%20computers%2C%20Microsoft%20Teams%20on%20screens%2C%20collaborative%20workspace%2C%20bright%20modern%20office%2C%20professionals%20working%2C%20technology%2C%20team%20meeting%20on%20video%20call%2C%20contemporary%20design&width=600&height=400&seq=portfolio-m365-5&orientation=landscape',
  },
  {
    id: 6,
    title: 'Firewall e Segurança de Rede',
    category: 'Segurança',
    description: 'Rede conectada e protegida contra ameaças externas — computadores, impressoras e internet funcionando com segurança, controle de acesso e proteção total dos dados da empresa.',
    tags: ['Firewall', 'Segurança', 'VPN'],
    image: 'https://readdy.ai/api/search-image?query=MikroTik%20router%20and%20network%20equipment%20in%20server%20rack%2C%20professional%20network%20security%20setup%2C%20multiple%20routers%20and%20switches%2C%20technical%20installation%2C%20green%20LED%20indicator%20lights%2C%20dark%20server%20room%20environment%2C%20close%20up&width=600&height=400&seq=portfolio-firewall-6&orientation=landscape',
  },
];

export default function PortfolioSection() {

  return (
    <section id="portfolio" className="bg-brand-surface py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="text-neon-green text-xs font-bold tracking-widest uppercase mb-3 block">
            Cases de Sucesso
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Projetos realizados na prática
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-sm">
            Infraestruturas que já implantamos para nossos clientes. Cada projeto entregue com qualidade e profissionalismo.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PROJECTS.map((project) => (
            <div
              key={project.id}
              className="bg-brand-card border border-brand-border rounded-xl overflow-hidden hover:border-neon-green/40 transition-all duration-300 group"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-card via-brand-card/20 to-transparent" />
                <span className="absolute top-3 right-3 bg-neon-green/90 text-black text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                  {project.category}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-white font-bold text-sm mb-2 leading-snug">{project.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed mb-4">{project.description}</p>
                <div className="flex flex-wrap gap-2">
                  {project.tags.map((tag) => (
                    <span
                      key={tag}
                      className="bg-neon-green/10 border border-neon-green/20 text-neon-green text-xs px-2 py-0.5 rounded-full whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
